import { ChartData } from "chart.js";

import { Translation } from "@/data/lang";

import { MarginTransactionsType } from "../../types/shared";
import {
  MarginTransaction,
  MarginTransactions,
} from "../services/margin-trading-short-selling";

const colorMap: Omit<Record<keyof MarginTransaction, string>, "date"> = {
  closePrice: "#0369A1",
  marginDiff: "#38BDF8",
  shortDiff: "#16A34A",
  marginUtilization: "#14B8A6",
  marginShortRatio: "#FB923C",
};

const chartTypeMap: Omit<
  Record<keyof MarginTransaction, "line" | "bar">,
  "date" | "closePrice"
> = {
  marginDiff: "bar",
  shortDiff: "bar",
  marginUtilization: "line",
  marginShortRatio: "line",
};

export const extractMarginTransactionsData = ({
  t,
  data,
  type,
}: {
  t: Translation;
  data: MarginTransactions;
  type: MarginTransactionsType;
}): ChartData<"bar" | "line"> => ({
  labels: data.map((d) => d.date),
  datasets: [
    {
      type: "line",
      label: t.analysis.chip.marginTransactions.closePrice,
      data: data.map((d) => d.closePrice ?? null),
      borderColor: colorMap.closePrice,
      backgroundColor: colorMap.closePrice,
      yAxisID: "y1",
      pointRadius: 0,
      spanGaps: true,
    },
    {
      type: chartTypeMap[type],
      label: t.analysis.chip.marginTransactions[type],
      data: data.map((d) => d[type] ?? null),
      borderColor: colorMap[type],
      backgroundColor: colorMap[type],
      yAxisID: "y",
      pointRadius: 0,
      spanGaps: true,
    },
  ],
});
